export default [
  {
    label: "Cobranças",
    icon: "fas fa-exchange-alt",
    items: [
      {
        label: "Transações",
        to: "/financial/transaction",
        icon: "fas fa-exchange-alt",
        controller: "Transaction",
        action: "List"
      },
      {
        label: "Vendas avulsas",
        to: "/financial/single-sale",
        icon: "fas fa-shopping-cart",
        controller: "SingleSale",
        action: "List"
      },
      {
        label: "Transações Cartão Crédito Recusadas",
        to: "/fraud/transaction-credit-card-refused",
        icon: "fas fa-credit-card",
        controller: "Transaction",
        action: "List"
      },
      {
        label: "Pagamentos Duplicados",
        to: "/financial/double-payment",
        icon: "fas fa-clone",
        controller: "DoublePayment",
        action: "List"
      },
      

    ]
  },
  {
    label: "Pagamentos",
    to: "/financial/payments",
    icon: "fas fa-piggy-bank",
    controller: "CheckingAccount",
    action: "ListMerchant"
  },
  {
    label: "Transferências bancárias",
    to: "/financial/transfer-register",
    icon: "fas fa-exchange-alt",
    controller: "TransferRegister",
    action: "List"
  },
  {
    label: "Dados bancários inválidos",
    to: "/financial/transferencia-recusada",
    icon: "fas fa-user-alt-slash", 
    controller: "TransferenciaRecusada",
    action: "Listar"
  },
  {
    separator: true
  },
  {
    label: "Clientes negativos",
    to: "/financial/checking-account-merchants-negative",
    icon: "fas fa-search-dollar",
    controller: "CheckingAccount",
    action: "ListMerchantNegative"
  },
  {
    separator: true
  },
  {
    label: "Antecipações a clientes",
    to: "/financial/advance-payments",
    icon: "fas fa-calendar-day",
    controller: "AdvancePayment",
    action: "List"
  },
];


// WEBPACK FOOTER //
// ./src/data/menu-item-internal/operational-menu.js